import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { UserAlreadyExistsError } from '../UserAlreadyExistError';

import {
	CreateAppUser,
	type CreateAppUserFieldsFragment,
	type CreateAppUserMutation,
	type CreateAppUserMutationVariables,
} from './index.graphql';

export type User = CreateAppUserFieldsFragment['user'];

export type CreateUserParams = CreateAppUserMutationVariables['input'];

export async function createUser(
	{ firstName, lastName, email, countryCode, signupMethod, signupContext, phoneNumber }: CreateUserParams,
	{ gql: { fetch } }: UtilityContext,
): Promise<User | boolean> {
	const input = { email, firstName, lastName, countryCode, signupMethod, signupContext, phoneNumber };
	const { data } = await fetch<CreateAppUserMutation, CreateAppUserMutationVariables>({
		path: '/createUser',
		query: CreateAppUser,
		variables: { input },
		rejectOnError: true,
		batched: false, // to ensure this rate limited mutation is not batched
	});
	switch (data.createUser.__typename) {
		case 'CreateUserAlreadyExistsError':
			throw new UserAlreadyExistsError(data.createUser);
		case 'CreatePendingUserSuccess':
			return data.createUser.success;
		case 'CreateUserSuccess':
			return data.createUser.user;
		default:
			throw new Error(data.createUser.__typename);
	}
}
